/**
 * Atribuição usuário↔projeto (SEC.4 no backend, S-073 na tela).
 *
 * Os três endpoints existiam desde a SEC.4 e **nada os chamava**. Isso não era
 * cosmético: o filtro por atribuição está ligado em `GET /api/projects`
 * (`is_membership_scoped`), então quem não é admin só vê os projetos aos quais foi
 * atribuído — e, sem tela que atribuísse, via uma lista vazia para sempre.
 *
 * Tipos vindos do gerador do OpenAPI, para deriva de schema aparecer como erro de
 * TS aqui e não em runtime.
 */

import apiClient from "./client";
import type { components } from "@/types/api.generated";

export type ProjectMember = components["schemas"]["ProjectMemberResponse"];
export type AssignableUser = components["schemas"]["AssignableUserResponse"];

export async function getProjectMembers(projectId: string): Promise<ProjectMember[]> {
  const res = await apiClient.get<ProjectMember[]>(`/api/projects/${projectId}/members`);
  return res.data;
}

/**
 * Candidatos à atribuição — o tenant inteiro, ativos.
 *
 * Rota separada de `GET /api/admin/users` de propósito. O motivo original era
 * papel — o roster era `admin` e conceder acesso é de `manager` para cima —, e
 * ele caducou: o roster desceu para `manager`. O que sustenta a separação hoje é
 * o resto: aqui a projeção é magra, só vêm contas ativas, e o alcance é por
 * projeto. Ver `project_members.py`.
 */
export async function getAssignableUsers(projectId: string): Promise<AssignableUser[]> {
  const res = await apiClient.get<AssignableUser[]>(
    `/api/projects/${projectId}/assignable-users`,
  );
  return res.data;
}

export async function addProjectMember(
  projectId: string,
  userId: string,
): Promise<ProjectMember> {
  const res = await apiClient.post<ProjectMember>(`/api/projects/${projectId}/members`, {
    user_id: userId,
  });
  return res.data;
}

export async function revokeProjectMember(projectId: string, userId: string): Promise<void> {
  await apiClient.delete(`/api/projects/${projectId}/members/${userId}`);
}
